import { Card, CardContent } from "../../../../shared/components/card/Card";
import { Button } from "../../../../shared/components/button/Button";
import TableDeleteButton from "../../../../shared/components/button/TableDeleteButton";
import { Separator } from "../../../../shared/components/separator/Separator";

const RoleInfoPanel = ({ role }) => {
  const DataLabel = ({ data, label }) => (
    <div className="flex flex-row gap-x-2 my-1 px-20">
      <div className="w-1/2 font-bold ml-2">{label}</div>
      <div className="w-1/2">{data}</div>
    </div>
  );

  return (
    <Card className="w-1/2 sm:col-span-2" x-chunk="dashboard-05-chunk-0">
      <CardContent className="pb-3 pt-3 flex flex-row gap-x-10">
        <div className="w-full">
          <div className="flex flex-row">
            <div className="w-1/2 text-xl font-bold text-end">{role?.name}</div>
            <div className="w-1/2 flex flex-row justify-end gap-x-1">
              <Button
                className="h-7 gap-1"
                onClick={() => alert("Funcionalidad pendiente")}
              >
                Editar
              </Button>
              <TableDeleteButton
                onClickHandler={() => alert(`Funcionalidad pendiente`)}
              />
            </div>
          </div>
          <Separator className="my-2" />
          <DataLabel data={role?.code} label="Código" />
          <DataLabel data={role?.name} label="Nombre" />
        </div>
      </CardContent>
    </Card>
  );
};

export default RoleInfoPanel;
